// eslint-disable-next-line import/prefer-default-export
export const GASSIEN_COLOR = '#385623'
